// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3FP3h","productName":"Table_productName__3h2GT"};